import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router";
import { useStore } from "@/stores/store-context";
import { observer } from "mobx-react";

export const RouterSync = observer(function RouterSync() {
  const { router } = useStore();
  const params = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    router.setParams(params as Record<string, string>);
  }, [params, router]);

  useEffect(() => {
    router.setSearchParams(Object.fromEntries(searchParams.entries()));
  }, [searchParams, router]);

  return null;
});
